<template>
  <div class="actionpanel__dashboard">
    <div class="content__wrapper">
      <div class="content__heading">
        <h1>Search results</h1>
      </div>
    </div>
<!--    <div class="row">-->
<!--      <div class="search__wrapper">-->
<!--        &lt;!&ndash;   Big Search input  goes here    &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
    <div class="row">
      <div class="search__row">
        <div class="panel__container">
          <Panel title="Fuseboxes" size="full"/>
        </div>
      </div>
      <div class="search__row">
        <div class="panel__container">
          <Panel title="Locations" size="full"/>
        </div>
      </div>
      <div class="search__row">
        <div class="panel__container">
          <Panel title="Labels" size="full"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Panel from '@/components/Parts/Panel'

export default {
  name: 'Dashboard',
  components: {
    Panel
  }
}
</script>
